import { reactive, toRefs } from 'vue'

const state = reactive({
  posts: []
})

export default toRefs(state)

